<template>
  <div class="bkPaner-Ver" >
    <div>
      <div>
        <el-form :inline="true" class="search-form">
          <el-form-item label="数据申请-合作人审核页面" style="font:20px" align="center">          
          </el-form-item>
        </el-form>
      </div>
      <div class="container" >
        <el-table
          :data="list"
          style="width: 100%">
          <el-table-column
            prop="idai"
            label="ID"
            v-if="false">
          </el-table-column>
          <el-table-column
            prop="name"
            label="申请人(Name)">
          </el-table-column>
          <el-table-column
            prop="useremail"
            label="邮箱(Email)">
          </el-table-column>
          <el-table-column
            v-if="false"
            prop="applycop"
            label="申请人机构(organization)">
          </el-table-column>
          <el-table-column
            prop="apply_date"
            label="申请日期(Date)">
          </el-table-column>
          <el-table-column
            prop="data_id"
            label="文件ID"
            v-if="false">
          </el-table-column>
          <el-table-column
            prop="obs_id"
            label="观测号(Obs id)">
          </el-table-column>
          <el-table-column
            prop="target"
            label="观测目标(target)">
          </el-table-column>
          <el-table-column
            prop="obs_mode"
            width="90"
            label="观测模式(Obs Mode)">
          </el-table-column>
          <el-table-column
            prop="proposal"
            width="90"
            label="观测提案(Proposal)">
          </el-table-column>
          <el-table-column
            prop="ptypeview"
            width="90"
            label="提案类型(Ptype)">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="数据用途(Purpose)">
          </el-table-column>
          <el-table-column
            prop="includes"
            label="申请范围(Scope of application)">
          </el-table-column>
          <el-table-column
            prop="auth_code"
            label="授权码"
            v-if="false">
          </el-table-column>
          <el-table-column
            v-if="false"
            prop="authed_date"
            label="授权日期">
          </el-table-column>
          <el-table-column
            v-if="false"
            prop="sys_validity"
            width="55"
            label="系统有效期">
          </el-table-column>
          <el-table-column
            v-if="false"
            prop="end_date"
            label="失效日期">
          </el-table-column>
          <el-table-column
            v-if="false"
            prop="auth_states"
            width="55"
            label="授权状态">
          </el-table-column>
          <el-table-column
            v-if="false"
            prop="state"
            label="申请状态">
          </el-table-column>
          <el-table-column
            width="150"
            label="审批意见(Audit opinion)">
            <template slot-scope="scope">
              <div class="selected-opion" >
                <div class="level-item" :class="{'level-item-active': scope.row.opion}"  @click="scope.row.opion=!scope.row.opion">同意(ok)</div>
                <div class="level-item" :class="{'level-item-active': !scope.row.opion}"  @click="scope.row.opion=!scope.row.opion">否决(no)</div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="total"
          :total="total">
        </el-pagination>   

        <div align="center">
          <el-button size="mini" type="primary" @click="bkpartnersverok" :disabled="verd">提交(Submit)</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'bkPanerVer',
  props: {
    batch: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      verd:false,
      // currentPage: 1,
      // pageSize: 20,
      total: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        batch: this.batch,
        // currentPage: this.currentPage,
        // pageSize: this.pageSize,
      }
      axios.post('/iapi/userappbkget', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list.map((item) => {
            let opion = true;
            let includes = '';
            switch(parseInt(item.includeproposal)){
              case 1:
                includes = '此数据(This data)';
                break;
              case 2:
                includes = '提案数据(Proposal data)';
                break;
              case 3:
                includes = '同源数据(Same target Data)';
                break;
            }
            return {
              ...item,
              opion,
              includes,
            }
          });

        } else {
          this.verd = true;
          this.$message.error('数据不存在或申请已经审核!');
        }
      });
    },
    // changePage(page) {
    //   this.currentPage = page;
    //   this.getData();
    // },
    onSubmit() {
      // this.currentPage = 1;
      this.getData();
    },
    // sizeChange() {
    //   this.getData();
    // },
    bkpartnersverok() {

      this.verd = true;
      const params = {
        list: this.list,
        batch: this.batch,
        moban:'usappbkpanerver',
      }
      axios.post('/iapi/bkpartners_Ver', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('审核完成！');
        }else{
          this.$message('审核报错！');
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">

.bkPaner-Ver{
  padding: 24px 56px;
  margin:0 auto;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
.content-line {
  font-size: 14px;
  color: #080808;
  height: 32px;
  line-height: 32px;
  display:inline-block;
  margin-right: 40px;
  em {
    color: #200242;
    font-weight: 600;
    font-style: normal;
    text-decoration: underline;
  }
}
.selected-opion {
  display: inline-flex;
  border: 1px solid #0058a3;
  margin-right: 6px;
  .level-item {
    padding: 3px 6px;
    color: #0058a3;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    border-right: 1px solid #0058a3;
  }
  .level-item:last-child{
    border-right: none;
  }
  .level-item-active {
    color: #fff;
    background: #0058a3;
    border-color: #fff;
  }
}
.content-item {
  font-size: 14px;
  color: #080808;
  height: 32px;
  line-height: 32px;
  em {
    color: #200242;
    font-weight: 600;
    font-style: normal;
    text-decoration: underline;
  }
}
</style>
